import { parentPublisherSettingsActionTypes } from './action-types';
import { parentPublisherSettingsActions } from './actions';

export { parentPublisherSettingsActionTypes, parentPublisherSettingsActions };
